import dayjs from "dayjs";

export const defaultDayjsFormat = "YYYY-MM-DDTHH:mm:ss.SSSZ";
export const getTimestamp = () => {
  return dayjs().format(defaultDayjsFormat);
};
